<template>
	<el-table height="auto" :data="tableData" size="mini">
		<el-table-column label="Day" min-width="100" align="center">
			<template slot-scope="scope">
				{{scope.row.reportDate | formatDate('YYYY-MM-DD', false)}}
			</template>
		</el-table-column>
		<el-table-column label="Site" prop="website" min-width="100" align="center">
		</el-table-column>
		<el-table-column label="Channel" prop="channel" min-width="100" align="center">
		</el-table-column>
		<el-table-column label="Campaign Name" prop="campaignName" min-width="150" align="center">
		</el-table-column>
		<el-table-column label="Campaign ID" prop="campaignId" min-width="150" align="center">
		</el-table-column>
		<el-table-column label="Country" prop="countryCode" min-width="150" align="center">
		</el-table-column>
		<el-table-column label="install" prop="install" min-width="150" align="center">
		</el-table-column>
		<el-table-column label="1d_gmv" prop="gmvL1" min-width="150" align="center" :formatter="cellNumberFormat">
		</el-table-column>
		<el-table-column label="2d_gmv" prop="gmvL2" min-width="150" align="center" :formatter="cellNumberFormat">
		</el-table-column>
		<el-table-column label="3d_gmv" prop="gmvL3" min-width="150" align="center" :formatter="cellNumberFormat">
		</el-table-column>
		<el-table-column label="4d_gmv" prop="gmvL4" min-width="150" align="center" :formatter="cellNumberFormat">
		</el-table-column>
		<el-table-column label="5d_gmv" prop="gmvL5" min-width="150" align="center" :formatter="cellNumberFormat">
		</el-table-column>
		<el-table-column label="6d_gmv" prop="gmvL6" min-width="150" align="center" :formatter="cellNumberFormat">
		</el-table-column>
		<el-table-column label="7d_gmv" prop="gmvL7" min-width="150" align="center" :formatter="cellNumberFormat">
		</el-table-column>
		<el-table-column label="3d_est_gmv" prop="estGmvL3" min-width="150" align="center" :formatter="cellNumberFormat">
		</el-table-column>
		<el-table-column label="7d_est_gmv" prop="estGmvL7" min-width="150" align="center" :formatter="cellNumberFormat">
		</el-table-column>
		<el-table-column label="14d_est_gmv" prop="estGmvL14" min-width="150" align="center" :formatter="cellNumberFormat">
		</el-table-column>
		<el-table-column label="1d_order" prop="orderL1" min-width="150" align="center">
		</el-table-column>
		<el-table-column label="2d_order" prop="orderL2" min-width="150" align="center">
		</el-table-column>
		<el-table-column label="3d_order" prop="orderL3" min-width="150" align="center">
		</el-table-column>
		<el-table-column label="4d_order" prop="orderL4" min-width="150" align="center">
		</el-table-column>
		<el-table-column label="5d_order" prop="orderL5" min-width="150" align="center">
		</el-table-column>
		<el-table-column label="6d_order" prop="orderL6" min-width="150" align="center">
		</el-table-column>
		<el-table-column label="7d_order" prop="orderL7" min-width="150" align="center">
		</el-table-column>
	</el-table>
</template>

<script>
	import TableCellData from './minixs/table-cell-data.js'
	export default {
		mixins: [TableCellData]
	}
</script>
